module.exports = __webpack_public_path__ + "img/zdd_certificate_invite.0e1052b6.png";